import React from "react";
import { StyleguideDocument } from "tsi-common-react/src/styleguide/StyleguideDocument";

import { Context } from "@reactivated";

import { Template as FinancingModal } from "../../templates/FinancingModalTemplate";
import { Template as SessionKeepAlive } from "../../templates/SessionKeepAliveTemplate";

type IProps = {
    storybook: boolean;
    children?: React.ReactNode;
};

/**
 * Sealy's styleguide document chrome, shared by the block and element
 * fixture templates. Mirrors the legacy _styleguide_base.html: the
 * typekit / fonts.net / Open Sans font links, the inlined logo.svg symbol
 * sheet (block markup references its <use> ids), the #content +
 * main.main-content wrappers, and the keep-alive / financing furniture the
 * production PageSkeleton also mounts.
 */
export const StyleguideChrome = (props: IProps): React.JSX.Element => {
    const chrome = React.useContext(Context).chrome;
    return (
        <StyleguideDocument
            storybook={props.storybook}
            htmlLang={chrome.html_lang}
            bodyId={chrome.body_id}
            legacyJsUrl={`${chrome.static_base}dist2/legacy.js`}
            extraHead={
                <>
                    {/* Typography via Adobe Typekit */}
                    <link
                        rel="stylesheet"
                        href="https://use.typekit.net/pkh3gvi.css"
                    />
                    <link
                        rel="stylesheet"
                        href="https://fonts.googleapis.com/css2?family=Open+Sans&display=swap"
                    />
                    <link
                        rel="stylesheet"
                        href="https://cdn.fonts.net/kit/3ed71a64-0d16-41ee-a9f9-a2bef9e08d96/3ed71a64-0d16-41ee-a9f9-a2bef9e08d96.css"
                    />
                </>
            }
            bodyStart={
                /* Inlined logo.svg -- the hidden <svg> symbol sheet referenced
                   by <use> in block markup. */
                <div
                    dangerouslySetInnerHTML={{ __html: chrome.logo_svg }}
                    style={{ display: "none" }}
                />
            }
            bodyEnd={
                <>
                    <SessionKeepAlive />
                    <FinancingModal />
                </>
            }
        >
            {props.storybook ? (
                props.children
            ) : (
                <>
                    <div id="content" />
                    <main role="main" className="main-content">
                        <div id="main-content" />
                        {props.children}
                    </main>
                </>
            )}
        </StyleguideDocument>
    );
};
